module.exports = __webpack_public_path__ + "img/edit.df149171.svg";